export class RegionGenConfig {
    AverageFarmSizeAcres;
    CityPeoplePerSqMile;
    HouseholdSize;
    LivestockPerPerson;
    PeoplePerCastle;
    PeoplePerRuinedCastle;
    PeoplePerSqMileFarmland;
    PercentageOfCastlesInOutskirts;
    PercentageOfLivestockIsFowl;
    RegionAgeYears;
    RegionPopulation;
    RegionSizeSqMiles;
    WarehousesPerBuildingMultiplier;
    constructor() {
        this.LivestockPerPerson = 2.2;
        this.PeoplePerCastle = 50000;
        this.PeoplePerRuinedCastle = 5000000;
        this.PercentageOfLivestockIsFowl = 0.68;
        this.PercentageOfCastlesInOutskirts = 0.25;
        this.PeoplePerSqMileFarmland = 180;
        this.AverageFarmSizeAcres = 20;
        this.HouseholdSize = 5;
        this.WarehousesPerBuildingMultiplier = 1.4;
        this.CityPeoplePerSqMile = 38500;
        this.RegionPopulation = 6600000;
        this.RegionAgeYears = 1000;
        this.RegionSizeSqMiles = 10000;
    }
}
//# sourceMappingURL=regiongenconfig.js.map